import styled from 'styled-components';

export const PdfPreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const PdfActions = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
  justify-content: flex-end;
`;

export const PdfIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  flex: 1;
  min-height: 600px;
`;
